module.exports = __webpack_public_path__ + "c88aad8d1410db3a4930fec44c092084.png";